import { CommonModule } from '@angular/common';
import { AfterViewInit, Component, ElementRef, Input, OnChanges, OnInit, SimpleChanges, ViewChild } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { selection } from '@modules/search/services/actions.service';
import { SearchService } from '@modules/search/services/search.service';
import { ButtonModule } from 'primeng/button';
import { InputTextareaModule } from 'primeng/inputtextarea';
import * as marked from 'marked';
import { DomSanitizer } from '@angular/platform-browser';
import { AuthService } from '@core/services/auth/auth.service';
import { TooltipModule } from 'primeng/tooltip';
import { SkeletonModule } from 'primeng/skeleton';
import { AccordionModule } from 'primeng/accordion';
import { CopyContentComponent } from '@shared/components/copy-content/copy-content.component';
import { SearchChatHistoryComponent } from "../../../components/search-chat/components/search-chat-history/search-chat-history.component";
import { SanitizerPipe } from '@shared/pipes/sanitizer.pipe';
import { SvgIconComponent } from '@ngneat/svg-icon';
@Component({
  selector: 'app-summarize-chat',
  standalone: true,
  imports: [
    CommonModule,
    InputTextareaModule,
    ReactiveFormsModule,
    FormsModule,
    ButtonModule,
    TooltipModule,
    SkeletonModule,
    AccordionModule,
    CopyContentComponent,
    SearchChatHistoryComponent,
    SanitizerPipe,
    SvgIconComponent
],
  templateUrl: './summarize-chat.component.html',
  styleUrl: './summarize-chat.component.scss',
})
export class SummarizeChatComponent implements OnInit, OnChanges, AfterViewInit {
  @Input() data!: any;
  md5!: string;
  subject = '';
  isShowHistory: boolean = false;
  maxHeight: string = '100%';
  @Input () selected : selection = {} as selection;
  messages: any[] = [];
  chatMessages: any[] = [];
  isLoadingChat: boolean = false;
  isSummaryDone: boolean = false;
  prompt: string = '';
  chatId : string = '';
  @ViewChild('messageContainer') private messageContainer!: ElementRef;

  constructor(protected _search: SearchService,
    private DomSanitizer : DomSanitizer,
    protected _auth : AuthService
  ) {}
  ngAfterViewInit(): void {
    this.scrollToBottom();
  }

  ngOnChanges(changes: SimpleChanges): void {
    this.md5 = this.data?._source.MD5;
    this.subject = this.data?._source?.metaData?.subject;
    if(this.selected && this.selected.isExplain){
      this.getContextExplainExplain();
    }
  }

  ngOnInit(): void {
    this.md5 = this.data?._source.MD5;
    this.subject = this.data?._source?.metaData?.subject
      ? this.data?._source?.metaData?.subject
      : null;
  }

  isError : boolean = false;
  errorMessage : string = 'Something went wrong. Please try again later.';
  retryAfter : number = 0;
  getSearchChat = () => {
    if (!this.md5) return;
    let body :any = {
      md5: this.md5,
      messages: this.chatMessages,
      esId : this.data?._id,
      esIndex : this.data?._index,
    };

    if(this.chatId.length > 0){
      body.chatId = this.chatId;
    }

    let messageResponse = {
      role: 'assistant',
      content: '',
    }
    this.messages.push(messageResponse);
    this.isLoadingChat = true;
    this.isShowHistory = false;
    this.isError = false;
    this.retryAfter = 0;
    this._search.postSearchEmailChat({}, body).subscribe({
      next: (resp: any) => {
        this.isLoadingChat = false;
        this.chatId = resp.chatId;
        let messageResponse = {
          role: 'assistant',
          content: resp.message.content,
        }
        this.messages.pop();
        this.messages.push(messageResponse);
        this.messagesToMarkDown();
        this.chatMessages.push(messageResponse);
        this.generateTypingEffect(messageResponse);
      },
      error: (error) => {
        console.log('error', error);
        this.isLoadingChat = false;
        this.isError = true;
        this.chatMessages.pop();
        this.retryAfter = error.error.retryAfter || 0;
        if(this.retryAfter > 0){
          let interval = setInterval(() => {
            if(this.retryAfter == 0){
              clearInterval(interval);
            }
            this.retryAfter -= 1;
          }, 1000);
        }
        this.errorMessage = error.error.message || 'Something went wrong. Please try again later.';
      },
    });
  };

  getSummary = () => {
    if (!this.md5) return;
    this.activeIndex = 0;
    let body = {
      md5: this.md5,
    }
    this.isLoadingChat = true;
    this.isSummaryDone = true;
    let messageResponse = {
      role: 'assistant',
      content: '',
    }
    this.messages.push(messageResponse);
    this.isShowHistory = false;
    this._search.postEmailSummary({}, body).subscribe({
      next: (resp: any) => {
        this.isLoadingChat = false;
        this.messages.pop();
        this.messages.push(resp);
        this.messagesToMarkDown();
        this.generateTypingEffect(resp);
      },
      error: (error) => {
        console.log('error', error);
        this.isLoadingChat = false;
        this.messages.pop();
        let errorResponse = {
          role: 'assistant',
          content: 'Sorry, I could not process your request. Please try again later.',
        }
        this.messages.push(errorResponse);
        this.isSummaryDone = false;
      },
    });
  }

  getContextExplainExplain = () => {
    this.activeIndex = 0;
    let body = {
      md5: this.md5,
      context: this.selected.context,
    }
    this.isLoadingChat = true;
    let messageResponse = {
      role: 'assistant',
      content: '',
    }
    this.messages.push(messageResponse);
    this.isShowHistory = false;
    this.isMessageAssistantLoading = true;
    this._search.postEmailExplain({}, body).subscribe({
      next: (resp: any) => {
        this.isLoadingChat = false;
        this.messages.pop();
        this.messages.push(resp);
        this.messagesToMarkDown();
        this.clearContext();
        this.generateTypingEffect(resp);
      },
      error: (error) => {
        console.log('error', error);
        this.isLoadingChat = false;
        this.messages.pop();
        this.clearContext()
        let errorResponse = {
          role: 'assistant',
          content: 'Sorry, I could not process your request. Please try again later.',
        }
        this.messages.push(errorResponse);
      },
    });
  }

  isMessageAssistantLoading: boolean = false;
  isMessageAssistantLoadedFirst: boolean = true;
  generateTypingEffect = (message: any) => {
    this.isMessageAssistantLoading = true;
    this.isMessageAssistantLoadedFirst = true;
    message.value = message.content;
    message.content = '';
    let words = message.value.split(' ');
    let i = 0;
    let interval = setInterval(() => {
      if (i < words.length) {
        message.content += (i > 0 ? ' ' : '') + words[i];
        i++;
        this.scrollToBottom();
      } else {
        this.isMessageAssistantLoading = false;
        delete message.value;
        clearInterval(interval);
        this.scrollToBottom();
      }
    }, 30);
  };

  sendMessage = () => {
    if (!this.prompt) return;
    let message : any = {
      role: 'user',
      content: this.prompt.trim().replace(/\n+$/, ''),
    };
    if(this.selected && this.selected.context && this.selected.context.length > 0){
      message.context = this.selected.context;
    }
    this.selected = {} as selection;
    this.messages.push(message);
    this.chatMessages.push(message);
    this.prompt = '';
    this.scrollToBottom();
    this.getSearchChat();
  };

  clearContext = () => {
    this.selected = {} as selection;
  }

  scrollToBottom = () => {
    try {
      setTimeout(() => {
        this.messageContainer.nativeElement.scrollTop = this.messageContainer.nativeElement.scrollHeight;
        this.maxHeight = (this.messageContainer.nativeElement.offsetHeight + 100)+ 'px';
      }, 100);
    } catch (err) {}
  }

  chatHistoryUpdate = (chatHistory: any) => {
    this.messages = [...chatHistory.messages];
    this.chatId = chatHistory.chatId;
    this.chatMessages = [...chatHistory.messages];
    this.prompt = '';
    this.scrollToBottom();
    this.messagesToMarkDown();
    this.isShowHistory = false;
  }

  activeIndex: any = -1;

  activeIndexChange(index : any){
      this.activeIndex = index
  }

  messagesToMarkDown = () => {
    this.messages.forEach((message) => {
      if(message.role === 'assistant'){
        message.content = marked.parse(message.content, { async : false});
      }
    });
  };

  startNewChat = () => {
    this.messages = [];
    this.chatMessages = [];
    this.chatId = '';
    this.isShowHistory = false;
  }

  retry = () => {
    this.getSearchChat();
  }
}
